/** Deep links for audit / ledger source docs — keep in sync with App routes. */
export function docLink(
  companySlug: string,
  docType: string | null | undefined,
  docId: string | null | undefined,
): string | null {
  if (!docType || !docId) return null;
  switch (docType) {
    case "sales_order":
      return `/c/${companySlug}/sales/orders/${docId}`;
    case "sales_delivery":
      return `/c/${companySlug}/sales/deliveries/${docId}`;
    case "customer_payment":
      return `/c/${companySlug}/sales/payments/${docId}`;
    case "purchase_order":
      return `/c/${companySlug}/purchasing/orders/${docId}`;
    case "goods_receipt":
      return `/c/${companySlug}/purchasing/receipts/${docId}`;
    case "supplier_payment":
      return `/c/${companySlug}/purchasing/payments/${docId}`;
    case "sales_return":
      return `/c/${companySlug}/returns/${docId}`;
    case "stock_conversion":
      return `/c/${companySlug}/inventory/conversions/${docId}`;
    case "pos_ticket":
      return `/c/${companySlug}/pos/tickets/${docId}`;
    case "journal_entry":
      return `/c/${companySlug}/gl/journals/${docId}`;
    case "product":
      return `/c/${companySlug}/products/${docId}`;
    case "customer":
      return `/c/${companySlug}/contacts?role=customer`;
    case "supplier":
    case "party":
      return `/c/${companySlug}/contacts`;
    case "override_request":
    case "change_request":
      return `/c/${companySlug}/approvals`;
    default:
      return null;
  }
}
